import styled from 'styled-components';

export const FormGroupContainer = styled.div`
  margin-bottom: 0.8rem;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 10px;
  width: 100%;
`;
